import React, { FC, memo, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { useGetCurrencySymbol } from 'app/appState';
import { ContractInfo } from 'entities/Contract';
import { BulletsTable, TableRow } from 'shared/ui/BulletsTable';
import { formatPrice } from 'shared/utils/helpers/formatPrice';

interface ModernTotalToPayCardProps {
  contractInfo: ContractInfo;
}

export const ModernTotalToPayCard: FC<ModernTotalToPayCardProps> = memo((props) => {
  const { contractInfo } = props;

  const { t } = useAppTranslation('booking');

  const currencySymbol = useGetCurrencySymbol();

  const priceDetailsBullets = useMemo(() => {
    const tableRows: TableRow[] = [];

    const totalWithVat = contractInfo.totalToPay;

    if (contractInfo.balanceToChargeAmount) {
      tableRows.push({
        label: t('Total to pay'),
        value: `${formatPrice(contractInfo.totalToCharge)} ${currencySymbol}`,
        highlighted: true,
      });
    } else {
      tableRows.push({
        label: t(
          `Total for ${
            contractInfo.payForEntirePeriod ? '{{contractDuration}} {{invoiceFrequencyTypes}}' : '1st {{invoiceFrequencyType}}'
          }`,
          {
            contractDuration: contractInfo.contractDuration,
            invoiceFrequencyType: t(contractInfo.invoiceFrequencyType),
            invoiceFrequencyTypes: t(`${contractInfo.invoiceFrequencyType}s`),
          },
        ),
        value: `${formatPrice(totalWithVat)} ${currencySymbol}`,
        highlighted: true,
      });
    }

    return tableRows;
  }, [
    contractInfo.totalToPay,
    contractInfo.balanceToChargeAmount,
    contractInfo.totalToCharge,
    contractInfo.payForEntirePeriod,
    contractInfo.contractDuration,
    contractInfo.invoiceFrequencyType,
    t,
    currencySymbol,
  ]);

  return (
    <div className="bg-white rounded-xl p-4">
      <BulletsTable rows={priceDetailsBullets} theme="clear" />
    </div>
  );
});
